const config = {
  fieldControl: false,
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      width: 190,
      fixed: 'left',
      render: 'clueIdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 200,
      render: 'nameRender'
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },

    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 260,
      ellipsis: true,
    },
    {
      title: '所属组织',
      dataIndex: 'orgName',
      width: 150,
    },
    {
      title: '云客服',
      dataIndex: 'seat',
      width: 150,
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 100,
    },
    {
      title: '到店次数',
      dataIndex: 'arriveCount',
      width: 100,
    },
    {
      title: '首访时间',
      dataIndex: 'firstDate',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '最后跟进时间',
      dataIndex: 'lastFollowTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 100,
      render: 'stateRender',
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 180,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    // {
    //   name: 'clueId',
    //   label: '商机ID',
    //   formItemProps: {
    //     getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
    //   },
    // },
    {
      name: 'bizType',
      label: '需求标签',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'typeListArr',
    },
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'number',
      span: 120,
    },
    {
      name: 'orgId',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'deptId',
      label: '部门',
      span: 120,
      itemType: 'tree',
      key: 'id',
      labelKey: 'label',
      data: 'saleDept',
      notFoundContent: '请选择公司或无匹配数据',
      events: ['filterOption:filterOption', 'onChange:onMarketerDepChange'],
    },
    {
      name: 'ucenterUserId',
      label: '营销员',
      span: 120,
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'salesman',
      notFoundContent: '请选择部门或无匹配数据',
    },
    {
      name: 'callUserId',
      label: '云客服',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'seat',
      span: 120,
    },
    {
      name: 'advertUserId',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'anchor',
      label: '优化师',
    },
    {
      name: 'status',
      label: '线索状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'clueStatusEnum',
    },

    {
      name: 'buildingId',
      label: '楼盘',
      span: 120,
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'buildingId',
      notFoundContent: '请选择公司或无匹配数据',
    },

    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'tree',
      data: 'channels',
      labelKey: 'label',
      key: 'id',
      treeCheckable: true,
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'channelBrandId',
      label: '品牌',
      span: 120,
      itemType: 'select',
      key: 'id',
      labelKey: 'brandName',
      data: 'channelBrand',
    },
    // {
    //   name: 'plan',
    //   label: '最小建筑面积',
    // },
    // {
    //   name: 'plan',
    //   label: '最大建筑面积',
    // },
    // {
    //   name: 'plan',
    //   label: '最后跟进',
    //   labelProps: { width : 65 },
    // },
    {
      name: 'firstDate',
      label: '首访日期',
      placeholder: ['首访日期起', '止'],
      span: 140,
      itemType: 'autoDate',
      showTime: 'true',
      labelProps: { width : 65 },
    },
  ],
  footer: [
    {
      label: '导出',
      render: 'exportRender',
    },
    {
      label :'新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
   ],
  batchActions: [
    {
      label :'批量改派',
      type: 'primary',
      auth: 'batchReassignmentSale',
      events: ['onClick:onBatchChange'],
    },
  ],
}

export default config
